module.exports = __webpack_public_path__ + "img/halloween_lovepotion.9b622f9e.svg";